module.exports = "<router-outlet ></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Projects/Isagenix/GitHub/Mobile.IsaLifeAzure/apps/qualia-platform-admin-web/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main